import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirplaneIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirplaneIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M11.2745 20.6655H8.85263C8.70615 20.6655 8.56747 20.6016 8.47226 20.4902C8.37753 20.3789 8.33603 20.2314 8.35898 20.0874L9.28183 14.272H6.0206L4.85947 15.9268C4.76621 16.0601 4.61338 16.1397 4.45029 16.1397H2.49961C2.34287 16.1397 2.19541 16.0659 2.10068 15.9409C2.00595 15.8159 1.97568 15.6538 2.01865 15.5029L3.02646 11.9526L2.01962 8.50049C1.97567 8.34912 2.00497 8.18604 2.0997 8.06055C2.19394 7.93457 2.34238 7.86035 2.4996 7.86035H4.45028C4.61141 7.86035 4.76278 7.93799 4.85653 8.06885L6.04598 9.72803H9.30721L8.35897 3.91504C8.33553 3.77002 8.37655 3.62256 8.47176 3.51074C8.56649 3.39892 8.70614 3.33447 8.85262 3.33447H11.2745C11.4825 3.33447 11.669 3.46338 11.7423 3.6582L14.0318 9.72802H18.8844C19.315 9.72802 19.7413 9.83886 20.1173 10.0478L21.2203 10.6616C21.7052 10.9321 21.9967 11.4248 22.0001 11.9795C22.003 12.5342 21.7174 13.0303 21.2354 13.3057L20.13 13.9375C19.7481 14.1562 19.3131 14.272 18.8717 14.272H13.9796L11.7437 20.3384C11.671 20.5352 11.484 20.6655 11.2745 20.6655ZM9.43808 19.6655H10.9259L13.1617 13.5991C13.2345 13.4023 13.4215 13.272 13.6309 13.272H18.8717C19.1388 13.272 19.4024 13.2021 19.6334 13.0698L20.7393 12.4375C20.9762 12.3022 21.0006 12.0762 21.0001 11.9853C20.9996 11.894 20.9723 11.6685 20.734 11.5356L19.6309 10.9219C19.4034 10.7949 19.1451 10.728 18.8844 10.728H13.6861C13.4781 10.728 13.2916 10.5991 13.2184 10.4043L10.9288 4.33446H9.44053L10.3888 10.1475C10.4122 10.2925 10.3712 10.4399 10.276 10.5518C10.1812 10.6636 10.0416 10.728 9.89512 10.728H5.78916C5.62803 10.728 5.47666 10.6504 5.38291 10.5195L4.19346 8.86034H3.16612L4.02696 11.8105C4.05333 11.9009 4.05382 11.9966 4.02794 12.0874L3.16124 15.1397H4.19005L5.35118 13.4849C5.44444 13.3516 5.59727 13.272 5.76036 13.272H9.86729C10.0138 13.272 10.1524 13.3359 10.2477 13.4473C10.3424 13.5586 10.3839 13.7061 10.3609 13.8501L9.43808 19.6655Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AirplaneIcon;
